import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { Alert as Alert$1 } from '@mui/material';
import { Icon } from '../Icon/Icon.js';
import { archerConstants } from '../../utils/themeProvider.js';
import { createButton } from '../../factories/button/button.factory.js';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var styles = {
  AlertRoot: {
    margin: '1rem',
    padding: '1rem',
    borderWidth: '2px',
    '&[class*="MuiAlert-outlinedError"]': {
      borderColor: '#C62828',
      '& [class*="MuiAlert-icon"]': {
        color: '#C62828'
      }
    },
    '&[class*="MuiAlert-outlinedInfo"]': {
      borderColor: '#1565C0',
      '& [class*="MuiAlert-icon"]': {
        color: '#1565C0'
      }
    },
    '&[class*="MuiAlert-outlinedSuccess"]': {
      borderColor: '#3E9342',
      '& [class*="MuiAlert-icon"]': {
        color: '#3E9342'
      }
    },
    '&[class*="MuiAlert-outlinedWarning"]': {
      borderColor: '#CC6600',
      '& [class*="MuiAlert-icon"]': {
        color: '#CC6600'
      }
    },
    '& [class*="MuiAlert-icon"]': {
      padding: '0 1rem 0 0',
      margin: 0
    },
    '& [class*="MuiAlert-message"]': {
      padding: '0',
      '& [class*="MuiTypography-root"]': {
        color: archerConstants.archerTextPrimary,
        '& [class*="MuiSvgIcon-root"]': {
          position: 'relative',
          marginTop: '-4px',
          top: '4px',
          padding: '0 4px'
        }
      }
    },
    '& [class*="MuiAlert-action"]': {
      alignItems: 'baseline',
      marginTop: '-5px',
      marginBottom: '-5px',
      '& button': {
        padding: '0 0.5rem',
        margin: 0,
        maxHeight: '1.875rem',
        color: 'primary.main',
        '&:hover': {
          color: archerConstants.archerContrastRatioSafe
        }
      }
    }
  }
};

var Alert = function Alert(_ref) {
  var actionList = _ref.actionList,
      severity = _ref.severity,
      className = _ref.className,
      content = _ref.content,
      dataProp = _ref.dataProp,
      sx = _ref.sx;
  var iconMapping = {
    success: /*#__PURE__*/React.createElement(Icon, {
      icon: 'CheckCircle',
      fontSize: "medium"
    }),
    error: /*#__PURE__*/React.createElement(Icon, {
      icon: 'Error',
      fontSize: "medium"
    }),
    info: /*#__PURE__*/React.createElement(Icon, {
      icon: 'Info',
      fontSize: "medium"
    }),
    warning: /*#__PURE__*/React.createElement(Icon, {
      icon: 'Warning',
      fontSize: "medium"
    })
  };
  var actionSection = actionList ? actionList.map(function (action) {
    return createButton(_objectSpread(_objectSpread({}, action), {}, {
      actionType: 'inherit',
      size: 'small'
    }));
  }) : undefined;
  return /*#__PURE__*/React.createElement(Alert$1, {
    sx: [styles.AlertRoot, sx],
    action: actionSection,
    severity: severity,
    iconMapping: iconMapping,
    variant: "outlined",
    className: className,
    "data-selector": dataProp
  }, content);
};

Alert.displayName = 'Alert';
export { Alert };